import { AuthState } from '@okta/okta-auth-js';

import { FuturesOptionMonths } from '../../services/backend/FuturesOptionMonths';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesOptionMonths: () => FuturesOptionMonths<AuthState> = () => {
  return useBaseApiClient(FuturesOptionMonths);
};
